// Module
var code = "<sales\n  article-id=\"vm.article.id\"\n  variant-id=\"vm.variant.id\"\n  customer-id=\"vm.article.customerId\"\n  article-node-group=\"vm.nodeGroup\"\n></sales>\n";
// Exports
module.exports = code;